'use client';
import { Button, Text } from '@instamenu/ui-system-next';
import { palette, themeVars } from '@instamenu/ui-vanilla-extract';
import { CartIcon } from '@instamenu/ui-icons';
import { useCheckoutContext } from '@instamenu/context-checkout';
import { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import * as styles from './cart-menu.css';
import { useUIStateContext } from '../ui-state-context/ui-state-context';

export const CartButton = observer(() => {
  const { setIsCartOpen } = useUIStateContext();
  const checkout = useCheckoutContext();
  const [isAnimating, setIsAnimating] = useState(false);
  const [prevNumItems, setPrevNumItems] = useState<number | undefined>();
  const numItems = checkout?.order?.numItems;

  useEffect(() => {
    // Skip the first render
    if (prevNumItems === undefined) {
      setPrevNumItems(numItems);
      return;
    }
    // Only animate if the number changed
    if (numItems !== prevNumItems) {
      setIsAnimating(true);
      setTimeout(() => setIsAnimating(false), 500);
      setPrevNumItems(numItems);
    }
  }, [numItems, prevNumItems]);

  return (
    <Button
      data-id="cart-tab"
      onClick={() => numItems && numItems > 0 && setIsCartOpen(true)}
      rectangular
      css={{
        backgroundColor: 'transparent',
        height: themeVars.sizes.inputHeight.sm,
        border: themeVars.border.default,
      }}
    >
      <CartIcon
        width={20}
        height={20}
        color={numItems && numItems > 0 ? themeVars.color.brand : palette.gray100}
        style={{ display: 'block' }}
        className={isAnimating ? styles.bouncing : ''}
      />
      {numItems && numItems > 0 ? (
        <Text variant="caption2" className={styles.numItems}>
          {numItems}
        </Text>
      ) : null}
    </Button>
  );
});
